export const EnvironmentStrToPrefix: { [key: string]: string } = {
  Development: 'd',
  Test: 't',
  Production: 'p'
};
